/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconForward.vue?vue&type=template&id=26aa3066&scoped=true"
import script from "./IconForward.vue?vue&type=script&lang=js"
export * from "./IconForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aa3066",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26aa3066')) {
      api.createRecord('26aa3066', component.options)
    } else {
      api.reload('26aa3066', component.options)
    }
    module.hot.accept("./IconForward.vue?vue&type=template&id=26aa3066&scoped=true", function () {
      api.rerender('26aa3066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconForward.vue"
export default component.exports